// extracted by mini-css-extract-plugin
module.exports = {"container":"resend-otp_container__HpAqb","resend-otp-msg":"resend-otp_resend-otp-msg__1ZIqf","resend-btn":"resend-otp_resend-btn__2RZ3U"};